<!-- Sentiment step — design carried over from the legacy 4-step flow. -->
<section class="thumbs-screen">
  <!-- Business hero: logo, name, personalised greeting, intro line -->
  <div class="business-hero">
    <img
      *ngIf="businessLogo"
      [src]="businessLogo"
      [alt]="businessName"
      class="business-logo"
    />
    <h1 class="business-title">{{ businessName | titlecase }}</h1>
    <p class="business-greeting" *ngIf="contactName">Hello {{ contactName }}!</p>
    <p class="business-welcome" *ngIf="welcomeMessage">{{ welcomeMessage }}</p>
  </div>

  <h2 class="heading">How was your overall experience with us?</h2>
  <p class="subheading">Tap the option that best describes your visit</p>

  <div class="thumbs-row">
    <button
      type="button"
      class="thumb-btn positive"
      [class.selected]="sentiment === 'positive'"
      [disabled]="busy"
      (click)="pick('up')"
      aria-label="Positive"
    >
      <img src="assets/images/thumbs-up.svg" alt="" />
      <span>Good</span>
    </button>

    <button
      type="button"
      class="thumb-btn negative"
      [class.selected]="sentiment === 'negative'"
      [disabled]="busy"
      (click)="pick('down')"
      aria-label="Negative"
    >
      <img src="assets/images/thumbs-down.svg" alt="" />
      <span>Needs Improvement</span>
    </button>
  </div>
</section>
